// The GAP level each operation of each GAP API needs, as APIM checks it: kept by hand in line with the named values
// apima<api>-cus-common-gap-operation-permissions. An operation APIM does not list needs admin.

export const GAP_OPERATIONS = {
  client: {
    delete: 'admin',
    getClientById: 'read',
    getClients: 'read',
    save: 'admin',
    update: 'write'
  },
  env: {
    delete: 'admin',
    delete_1: 'admin',
    deleteAll: 'admin',
    deleteAll_1: 'admin',
    get: 'read',
    getAllV1: 'read',
    getAllV2: 'read',
    getV1: 'read',
    getV2: 'read',
    ping: 'read',
    // The GAINS Connect proxy, one operation per verb: GET, then POST/PUT/PATCH, then DELETE
    proxyDelete: 'admin',
    proxyPost: 'write',
    proxyPost_1: 'write',
    proxyPost_2: 'write',
    proxyRead: 'read',
    refreshEnvironmentStatus: 'read',
    refreshEnvironmentStatus_1: 'read',
    saveV1: 'write',
    saveV2: 'write',
    search: 'read',
    startScans: 'read',
    updateV1: 'write',
    updateV2: 'write'
  },
  partner: {
    delete: 'admin',
    delete_1: 'admin',
    deleteAll: 'admin',
    get: 'read',
    getAll: 'read',
    getPartnerById: 'read',
    getPartnerMappingValueTypes: 'read',
    getPartners: 'read',
    patch: 'write',
    save: 'write',
    save_1: 'write',
    update: 'write'
  },
  alert: {
    bulkUpdate: 'write',
    cleanup: 'write',
    create: 'write',
    deleteByEnvironment: 'admin',
    getAlertById: 'read',
    getAlerts: 'read',
    getAlertsSummary: 'read',
    getEnvironmentConfig: 'read',
    getScanById: 'read',
    getScans: 'read',
    getSchema: 'read',
    resolveBatch: 'write',
    save: 'write',
    save_1: 'write',
    update: 'write',
    updateAlertTypes: 'write',
    updateScan: 'write',
    updateSchedule: 'write'
  },
  envserv: {
    createService: 'write',
    deleteAllServices: 'admin',
    deleteService: 'admin',
    getEnvironmentIdsByStatuses: 'read',
    getService: 'read',
    getServices: 'read',
    patchService: 'write',
    searchServices: 'read'
  },
  ident: {
    createAuthSettings: 'write',
    deleteAuthSettings: 'admin',
    deleteUser: 'admin',
    get: 'read',
    get_1: 'read',
    getAuthSettings: 'read',
    getEffectiveConfig: 'read',
    getHistory: 'read',
    getLatestStatus: 'read',
    getPasswordPolicy: 'read',
    getUsersByDomain: 'read',
    inviteUser: 'admin',
    patchAuthSettings: 'write',
    resendUserInvitation: 'admin',
    resetUserPassword: 'admin',
    submit: 'write',
    updateUser: 'admin',
    updateUserStatus: 'admin'
  },
  ltp: {
    deleteScheduling: 'admin',
    getConfiguration: 'read',
    getConfiguration_1: 'read',
    getLog: 'read',
    getScheduling: 'read',
    getTemplate: 'read',
    getTemplate_1: 'read',
    runEgress: 'write',
    runFull: 'write',
    update: 'write',
    update_1: 'write',
    updateScheduling: 'write'
  }
} as const;
